import * as z from "zod";
import { Discipline } from "model/result/discipline";

export const ResultSchema = z.object({
  id: z.number(),
  userId: z.number(),
  discipline: z.nativeEnum(Discipline),
  date: z.string(),
  championshipName: z.string(),
  totalScore: z.number(),
  avgScore: z.number(),
  rank: z.number(),
});

export type Result = z.infer<typeof ResultSchema>;
